export var StockDetailsLineChartData = {
    data(){
        return{
            line_graph_legend: {
                type: 'scroll',
                itemGap : 20,
                top: 10,
                show: true,
            },
            
            stock_performance_chart_colors: ['#53dda8'],
            roi_performance_chart_colors: ['#00ca6f', '#f95c89'],

            line_chart_legends: [],
            
            stock_performance_chart_series: [],

            stock_performance_chart_yaxis: {
                type: 'value',
                position: 'right',
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                axisLabel: {
                    fontSize: 11,
                    fontStyle: 'normal',
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat',
                    color: '#7a7a7a',
                    margin: 10,
                    formatter: '₹ {value}'
                },
                splitLine: {
                    show: false
                },
            },
            
            stock_performance_chart_xaxis:{
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#ddd',
                        width: 1 ,
                        type: 'solid' 
                    },
                },
                axisLabel: {
                    fontSize: 11 ,
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    color: '#7a7a7a',
                    margin: 10
                },
                type: 'category',
                data: []
                // boundaryGap: false,
                // data: [],
                // scale : true,
                // min:0,
                // max: '',
            },

            roi_performance_chart_series: [],

            roi_performance_chart_yaxis: {
                type: 'value',
                position: 'right',
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                axisLabel: {
                    fontSize: 11,
                    fontStyle: 'normal',
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat',
                    color: '#7a7a7a',
                    margin: 10,
                    formatter: '{value} %'
                },
                splitLine: {
                    show: false
                },
            },
            
            roi_performance_chart_xaxis:{
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#ddd',
                        width: 1 ,
                        type: 'solid' 
                    },
                },
                axisLabel: {
                    fontSize: 11 ,
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat' ,
                    color: '#7a7a7a',
                    margin: 10
                },
                type: 'category',
                data: []
                // boundaryGap: false,
                // data: [],
                // scale : true,
                // min:0,
                // max: '',
            },

            market_performance_chart_series: [
                {
                    name: 'Number of \n Recos.',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                        backgroundColor: '#F6F8FC',
                        borderColor: '#8C8D8E',
                        borderWidth: 1,
                        borderRadius: 4,
                        
                        rich: {
                            a: {
                                color: '#6E7079',
                                lineHeight: 22,
                                align: 'center'
                            },
                            hr: {
                                borderColor: '#8C8D8E',
                                width: '100%',
                                borderWidth: 1,
                                height: 0
                            },
                            b: {
                                color: '#4C5058',
                                fontSize: 14,
                                fontWeight: 'bold',
                                lineHeight: 33
                            },
                            per: {
                                color: '#fff',
                                backgroundColor: '#4C5058',
                                padding: [3, 4],
                                borderRadius: 4
                            }
                        }
                    },
                    emphasis: {
                        label: {
                            show: true,
                            position: 'inside' ,
                            // color: "#000" ,
                            fontStyle: 'normal' ,
                            fontWeight: 'normal' ,
                            fontFamily: 'Montserrat' ,
                            fontSize: 11 ,
                        }
                        
                    },
                    labelLine: {
                        show: true
                    },
                    data: []
                }
            ],

            initOptions : {renderer : 'svg'},
        }
    },

    computed : {
        stockPerformanceChart : function(){
            return {
                title : {
                    show : true,
                    color: '#000',
                    // padding: 20,
                },
                tooltip: {
                    trigger: 'axis',
                    // formatter : function(params){
                    //     var temp = '';
                    //     temp = temp + params[0].name + '</br>';     //displayed triggered x-axis
                    //     for(var i=0;i<params.length;i++){
                    //         temp = temp + params[i].marker + params[i].seriesName + ' '+ (params[i].value == undefined ? '-' : params[i].value) + (params[i].value == undefined ? ' ' : '%') + '</br>';
                    //     }
                    //     return temp;
                    // },
                    formatter : (params) => (`${params[0].name}<br/><span style="background-color: ${params[0].color}; border-radius: 50px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;${params[0].seriesName}: ₹ ${params[0].value}`)
                },
                legend: {
                    show: false,
                    data: this.line_chart_legends
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: this.stock_performance_chart_yaxis,
                xAxis: this.stock_performance_chart_xaxis,
                color: this.stock_performance_chart_colors,
                series: this.stock_performance_chart_series,
            }
        },

        roiPerformanceChart : function(){
            return {
                title : {
                    show : true,
                    color: '#000',
                    // padding: 20,
                },
                tooltip: {
                    trigger: 'axis',
                    // formatter : function(params){
                    //     var temp = '';
                    //     temp = temp + params[0].name + '</br>';     //displayed triggered x-axis
                    //     for(var i=0;i<params.length;i++){
                    //         temp = temp + params[i].marker + params[i].seriesName + ' '+ (params[i].value == undefined ? '-' : params[i].value) + (params[i].value == undefined ? ' ' : '%') + '</br>';
                    //     }
                    //     return temp;
                    // },
                    formatter : (params) => (`${params[0].name}<br/><span style="background-color: ${params[0].color}; border-radius: 50px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;${params[0].seriesName}: ${params[0].value} %`)
                },
                legend: {
                    show: false,
                    data: this.line_chart_legends
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: this.roi_performance_chart_yaxis,
                xAxis: this.roi_performance_chart_xaxis,
                color: this.roi_performance_chart_colors,
                series: this.roi_performance_chart_series,
            }
        },

        marketPerformanceChart : function(){
            return {
                title : {
                    show : true,
                    color: '#000',
                    // padding: 20,
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    show: false,
                    top: '5%',
                    left: 'center'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                series: this.market_performance_chart_series,
            }
        }
    }
}